import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { useContext, useCallback } from 'react';
import { t } from 'Src/i18n';
import type { Plan } from 'Components/widgets/payment-info/payment-form/PaymentPlan';
import 'Components/widgets/payment-info/payment-form/PaymentPlan';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { useDispatch } from 'react-redux';
import { startLoading } from 'Store/global-loader/globalLoader.action';
import { useBookingNavbar } from 'Components/widgets/booking-navbar/useBookingNavbar';
import { submitBuyNowPayLater } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils';
import { castAs } from 'Src/types/cast-helpers';
type Props = {
  selectedPaymentProvider: any;
  paymentPlans: Array<Plan>;
  isIframe: boolean;
  showPaymentMethodWithConditions?: boolean;
  paymentMethodLabel: string;
};
export const useBankingNavbar = ({
  selectedPaymentProvider,
  paymentPlans,
  isIframe,
  showPaymentMethodWithConditions,
  paymentMethodLabel,
}: Props) => {
  const formik = useFormikContext<PaymentFormValues>();
  const { isFreeDeposit, isBuyNowPayLaterProcessComplete } = useContext(PaymentInfoContext);
  const dispatch = useDispatch();
  const selectedBuyNowPayLaterPlan = paymentPlans.find(
    ({ value }) => value === formik.values.paymentProviderId,
  );
  const isBuyNowPayLaterProcess = !!selectedBuyNowPayLaterPlan?.isIframe;
  const hideContinueButton =
    (isIframe && formik.isValid) ||
    (isIframe && showPaymentMethodWithConditions) ||
    (isBuyNowPayLaterProcess && !isBuyNowPayLaterProcessComplete);
  const isPaymentMethodNotSelected =
    selectedPaymentProvider?.paymentMethods &&
    selectedPaymentProvider.paymentMethods.length > 1 &&
    !formik.values.paymentMethodId;
  const validationCallback = useCallback(() => {
    if (isFreeDeposit) {
      formik.values.amountToPay = castAs<number>(formik.values.freeDeposit);
    }

    if (isBuyNowPayLaterProcess) {
      dispatch(startLoading());
      submitBuyNowPayLater(castAs<string>(selectedBuyNowPayLaterPlan?.value));
    } else {
      formik.submitForm();
    }

    return Promise.reject();
  }, [isFreeDeposit, paymentMethodLabel, isBuyNowPayLaterProcess]);
  useBookingNavbar({
    priceShouldIncludeDonation: !isBuyNowPayLaterProcess,
    isDisabled: isPaymentMethodNotSelected && !isBuyNowPayLaterProcessComplete,
    hideContinueButton,
    validationCallback,
    paymentLabel:
      isBuyNowPayLaterProcess && t('booking.priceDetails.packagePrice.completeBookingLabel'),
  });
};
